import React from "react";
import Hero from "@/components/site/Hero";
import RateCompare from "@/components/site/RateCompare";
import ServicesGrid from "@/components/site/ServicesGrid";
import MortgageCTAForm from "@/components/site/MortgageCTAForm";
import MQLendersCarousel from "@/components/site/MQLendersCarousel";
import MortgageCalculatorsSuite from "@/components/site/MortgageCalculatorsSuite";
import LeadWizard from "@/components/site/LeadWizard";
import Process from "@/components/site/Process";
import FAQ from "@/components/site/FAQ";
import CTABanner from "@/components/site/CTABanner";
import AdvisorVideo from "@/components/site/AdvisorVideo";
import MortgageNews from "@/components/site/MortgageNews";
import { QuickActionsStack } from "@/components/site/QuickActions";

export default function Home() {
    return (
        <>
            {/* Hero — single focused CTA above the fold (no competing paths). */}
            <Hero />
            <RateCompare />
            <ServicesGrid />
            {/* Secondary self-serve tools (Check my file, Compare rates, Book,
                Calculators, etc.) live further down so they don't compete
                with the hero quote form for attention. */}
            <QuickActionsStack />
            <MortgageCTAForm />
            <LeadWizard />
            <MQLendersCarousel />
            <MortgageCalculatorsSuite />
            <AdvisorVideo />
            <Process />
            <MortgageNews />
            <FAQ />
            <CTABanner />
        </>
    );
}
